/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const newFormSectionTokens = {
  DividerThicknessBaseDefault: '1px',
  DividerThicknessInvalidDefault: '2px',
  DividerColorBaseDefault: '#dedfdf',
  FontSizeTitleDefault: '16px',
  FontSizeSubtitleDefault: '14px',
  FontWeightTitleDefault: '500',
  FontWeightSubtitleDefault: '400',
  FontLeadingTitleDefault: '28px',
  FontLeadingSubtitleDefault: '24px',
} as const;
